import AppRoutes from "./routes/AppRoutes";
import { Toaster } from 'react-hot-toast';
import InstallPwaBanner from "./Components/InstallPwaBanner/InstallPwaBanner";

function App() {
  return (
    <>
      <AppRoutes />
      <Toaster position="top-right" reverseOrder={false} />
      <InstallPwaBanner />
    </>
  );
}

export default App;